import script from "./UrlPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./UrlPreview.vue?vue&type=script&setup=true&lang=ts"

import "./UrlPreview.vue?vue&type=style&index=0&id=9a2a2aa2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a2a2aa2"]])

export default __exports__